var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('NavBar'),_c('v-main',[_c('v-container',{attrs:{"fluid":"","id":"dashboard-vue"}},[_c('router-view')],1)],1),_c('v-footer',{staticStyle:{"background-color":"#265b93"},attrs:{"color":"darken-3","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© "+_vm._s(_vm.todayDate))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }